import { SET_EXERCICE } from "../actions/exerciceAction";

// Exercice sélectionné dans le header, lu par les actions (getState) pour les endpoints concernés.
// Non persisté : l'année en cours est restaurée à chaque chargement de l'app.
const initialState = {
  annee: new Date().getFullYear(),
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_EXERCICE:
      return {
        ...state,
        annee: action.annee,
      };
    default:
      return state;
  }
}
